"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Cookies = __importStar(require("js-cookie"));
var React = __importStar(require("react"));
var arrowDown_icon_1 = require("../../../svg/status/arrowDown.icon");
var historicalNavigation_1 = require("../../historical-report/navigation/historicalNavigation");
var reportNavigation_styles_1 = require("./reportNavigation.styles");
var core_components_1 = require("@securityproducts/core-components");
var reportNavigation_i18n_1 = require("./reportNavigation.i18n");
function ReportNav(props) {
    var _a = React.useState(props.dateTime || undefined), dateTime = _a[0], setDateTime = _a[1];
    var _b = React.useState(props.selectedAgentId || undefined), selectedAgentId = _b[0], setSelectedAgentId = _b[1];
    var _c = React.useState(props.selectedAgentId || undefined), passedInAgentId = _c[0], setPassedInAgentId = _c[1];
    var _d = React.useState(false), showSelect = _d[0], setShowSelect = _d[1];
    var _e = React.useState(false), showAgentSelect = _e[0], setShowAgentSelect = _e[1];
    var selectNode = React.useRef(null);
    var agentSelectNode = React.useRef(null);
    var _f = React.useState(undefined), range = _f[0], setRange = _f[1];
    var strings = core_components_1.useLocalisation(reportNavigation_i18n_1.reportNavigationTranslations, props.language);
    function handleClick(e) {
        if (selectNode.current && selectNode.current.contains(e.target)) {
            setShowAgentSelect(false);
            return;
        }
        if (agentSelectNode.current &&
            agentSelectNode.current.contains(e.target)) {
            setShowSelect(false);
            return;
        }
        setShowSelect(false);
        setShowAgentSelect(false);
    }
    React.useEffect(function () {
        document.addEventListener("mousedown", handleClick, false);
        return function () {
            document.removeEventListener("mousedown", handleClick, false);
        };
    }, []);
    // selectedAgentId props changed, so select that agent Id
    if (props.selectedAgentId !== undefined && props.selectedAgentId !== passedInAgentId) {
        setSelectedAgentId(props.selectedAgentId);
        setPassedInAgentId(props.selectedAgentId);
    }
    var selectedAgent = props.agents.find(function (agent) { return agent.id === selectedAgentId; });
    if (!selectedAgent && props.selectedAgentId != undefined) {
        selectedAgent = props.agents.find(function (agent) { return agent.id === props.selectedAgentId; });
    }
    var selectedAgentName = selectedAgent ? selectedAgent.name : strings.selectAgent;
    return (React.createElement("div", { id: "report-nav", className: reportNavigation_styles_1.container },
        React.createElement("div", { className: props.hideHistorical ? reportNavigation_styles_1.title : reportNavigation_styles_1.titleWithPointer, ref: selectNode, id: "report", onClick: function () {
                if (!props.hideHistorical) {
                    setShowSelect(!showSelect);
                }
            } },
            React.createElement("div", { id: "report-select", className: reportNavigation_styles_1.titleContent }, props.isHistorical ? strings.historicalReport : strings.activeReport),
            !props.hideHistorical && (React.createElement("div", { className: reportNavigation_styles_1.downArrow },
                React.createElement(arrowDown_icon_1.ArrowDownIcon, null))),
            showSelect ? (React.createElement("div", { id: "report-options", className: reportNavigation_styles_1.modalReport, ref: selectNode },
                React.createElement("div", { className: props.isHistorical
                        ? reportNavigation_styles_1.titleModalButton + " options"
                        : reportNavigation_styles_1.titleModalButtonActive + " options", "data-qa": "report", onClick: function () {
                        setShowSelect(false);
                        props.routeToActive();
                    } }, strings.activeReport),
                React.createElement("div", { className: props.isHistorical
                        ? "" + reportNavigation_styles_1.titleModalButtonActive
                        : "" + reportNavigation_styles_1.titleModalButton, "data-qa": "report", onClick: function () {
                        setShowSelect(false);
                        props.routeToHistorical();
                    } }, strings.historicalReport))) : (undefined)),
        React.createElement("div", { id: "agent", ref: agentSelectNode, className: showAgentSelect ? "" + reportNavigation_styles_1.buttonSelected : "" + reportNavigation_styles_1.options, onClick: function () {
                setShowAgentSelect(!showAgentSelect);
            } },
            React.createElement("div", { className: reportNavigation_styles_1.wrap, id: "agent-select", "data-showing": showAgentSelect }, selectedAgentName),
            React.createElement("div", { className: reportNavigation_styles_1.downArrow },
                React.createElement(arrowDown_icon_1.ArrowDownIcon, null)),
            showAgentSelect ? (React.createElement("div", { id: "agent-options", className: reportNavigation_styles_1.modal, ref: agentSelectNode }, props.agents.map(function (agent) { return (React.createElement("div", { className: agent.id === selectedAgentId
                    ? reportNavigation_styles_1.titleModalButtonActive + " options"
                    : reportNavigation_styles_1.titleModalButton + " options", "data-qa": "agent", key: agent.id, onClick: function () {
                    setSelectedAgentId(agent.id);
                    setShowAgentSelect(false);
                    if (!props.isHistorical) {
                        props.getReport({
                            guid: Cookies.get("guid"),
                            agent: agent.id,
                        });
                    }
                } }, agent.name)); }))) : (undefined)),
        props.isHistorical ? (React.createElement(historicalNavigation_1.HistoricalNav, __assign({}, dateTime, { display: props.display, agent: selectedAgentId, showDatePicker: props.showDatePicker, setDateTime: setDateTime, getReport: props.getReport, timezone: props.timezone, customDateAllowed: props.customDateAllowed, archivedReportsAvailable: props.archivedReportsAvailable, archiveDataFrom: props.archiveDataFrom, callSummaryDataFrom: props.callSummaryDataFrom, range: range, setRange: setRange, loading: props.loading, setLoading: props.setLoading, language: props.language }))) : (undefined)));
}
exports.ReportNav = ReportNav;
